import React from "react";
import { Box } from "@mui/material";
import { getContrastColor } from "../risk/bottombar/LegendStyle";

type AlertHeaderBannerProps = {
    eventType: string,
    color: string,
};

export const AlertHeaderBanner: React.FC<AlertHeaderBannerProps> = ( { eventType, color } ) => (
    <Box
        sx = {{
            backgroundColor: color,
            color: getContrastColor( color ),
            padding: "6px 10px",
            borderRadius: "6px",
            textAlign: "center",
            fontWeight: "bold",
            mb: 1
        }}
    >
        {eventType}
    </Box>
);
